/* global wc_country_select_params */

function getBeneficiarySelectWooArgs($, $el) {
    const args = {
        placeholder: $el.attr('data-placeholder') || $el.attr('placeholder') || '',
        width: '100%',
        dropdownParent: $(document.body),
    };

    if (typeof wc_country_select_params === 'undefined') {
        return args;
    }

    return $.extend(args, {
        language: {
            errorLoading() {
                return wc_country_select_params.i18n_searching;
            },
            inputTooLong(over) {
                const chars = over.input.length - over.maximum;
                return chars === 1
                    ? wc_country_select_params.i18n_input_too_long_1
                    : wc_country_select_params.i18n_input_too_long_n.replace('%qty%', chars);
            },
            inputTooShort(under) {
                const chars = under.minimum - under.input.length;
                return chars === 1
                    ? wc_country_select_params.i18n_input_too_short_1
                    : wc_country_select_params.i18n_input_too_short_n.replace('%qty%', chars);
            },
            loadingMore() {
                return wc_country_select_params.i18n_load_more;
            },
            maximumSelected(max) {
                return max.maximum === 1
                    ? wc_country_select_params.i18n_selection_too_long_1
                    : wc_country_select_params.i18n_selection_too_long_n.replace('%qty%', max.maximum);
            },
            noResults() {
                return wc_country_select_params.i18n_no_matches;
            },
            searching() {
                return wc_country_select_params.i18n_searching;
            },
        },
    });
}

function bindBeneficiarySelectLabel($el, $) {
    $el
        .off('select2:select.beneficiaryLabel select2:open.beneficiaryLabel select2:close.beneficiaryLabel')
        .on('select2:select.beneficiaryLabel select2:open.beneficiaryLabel', function () {
            $(`label[for="${this.id}"]`).addClass('active');
        })
        .on('select2:close.beneficiaryLabel', function () {
            if (!$el.val()) {
                $(`label[for="${this.id}"]`).removeClass('active');
            }
        });
}

function initCountrySelect($el, $, { force = false, bindLabel = false } = {}) {
    if (!$?.fn?.selectWoo || !$el.length) {
        return;
    }

    if (!force && $el.hasClass('select2-hidden-accessible')) {
        return;
    }

    if ($el.hasClass('select2-hidden-accessible')) {
        $el.selectWoo('destroy');
    }

    $el.next('.select2-container').remove();

    if (bindLabel) {
        bindBeneficiarySelectLabel($el, $);
    }

    $el.selectWoo(getBeneficiarySelectWooArgs($, $el));

    if (bindLabel && $el.val()) {
        $(`label[for="${$el.attr('id')}"]`).addClass('active');
    }
}

let checkoutSelectClickOpenBound = false;

function bindCheckoutSelectClickOpen($) {
    if (checkoutSelectClickOpenBound) {
        return;
    }

    checkoutSelectClickOpenBound = true;

    const fieldSelector = '.beneficiary-location-field, #billing_country_field';
    const containerSelector = '.beneficiaries .select2-container, #billing_country_field .select2-container';

    function openSelectFromEvent(e) {
        if ($(e.target).closest('.select2-dropdown').length) {
            return;
        }

        let $select = $(e.currentTarget).find('select').first();

        if (!$select.length && $(e.currentTarget).hasClass('select2-container')) {
            $select = $(e.currentTarget).prev('select');
        }

        if (!$select.length || !$select.hasClass('select2-hidden-accessible')) {
            return;
        }

        const instance = $select.data('select2');

        if (!instance || instance.isOpen()) {
            return;
        }

        $select.selectWoo('open');
    }

    $(document)
        .on('mousedown.checkoutSelectOpen', fieldSelector, openSelectFromEvent)
        .on('mousedown.checkoutSelectOpen', containerSelector, openSelectFromEvent);
}

function fixBillingCountrySelect() {
    const $ = window.jQuery;

    initCountrySelect($('#billing_country'), $, { force: true });
}

function refreshBeneficiaryCountrySelects(root) {
    const $ = window.jQuery;

    if (!$?.fn?.selectWoo) {
        return;
    }

    const scope = root || document;

    $(scope).find('.beneficiaries select.beneficiary-country-select:visible').each(function () {
        initCountrySelect($(this), $, { bindLabel: true });
    });
}

function scheduleBeneficiaryCountrySelects() {
    let attempts = 0;

    const tick = () => {
        const $ = window.jQuery;

        if (!$?.fn?.selectWoo) {
            if (++attempts < 40) {
                setTimeout(tick, 100);
            }
            return;
        }

        refreshBeneficiaryCountrySelects(document);

        const total = $('.beneficiaries select.beneficiary-country-select').length;
        const done = $('.beneficiaries select.beneficiary-country-select.select2-hidden-accessible').length;

        if (total > 0 && done < total && ++attempts < 40) {
            setTimeout(tick, 100);
        }
    };

    tick();
}

function qtyControl() {
    if (window.jQuery) {
        window.jQuery(function () {
            bindCheckoutSelectClickOpen(window.jQuery);
            scheduleBeneficiaryCountrySelects();
            setTimeout(fixBillingCountrySelect, 300);
        });

        window.jQuery(document.body).on('country_to_state_changed', function () {
            setTimeout(fixBillingCountrySelect, 0);
        });
    } else {
        scheduleBeneficiaryCountrySelects();
    }

    function acLog(msg) {
        const sessionId = (typeof themeVars !== 'undefined' && themeVars.log_session) ? themeVars.log_session : '--------';
        const data = new URLSearchParams();
        data.append('action', 'ac_client_log');
        data.append('nonce', themeVars.nonce);
        data.append('msg', '[' + sessionId + '] ' + msg);
        fetch(themeVars.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data.toString(),
            keepalive: true,
        }).catch(() => {});
    }

    let isUpdatingQty = false;
    let pendingQty     = null;
    let pendingCartKey = null;
    const forcedQtyValues = {};

    function syncForcedQtyInput(cartKey, qty) {
        forcedQtyValues[cartKey] = qty;
        const form = document.querySelector('form.checkout');
        if (!form) return;
        let hidden = form.querySelector(`input[name="forced_qty[${cartKey}]"]`);
        if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = `forced_qty[${cartKey}]`;
            form.appendChild(hidden);
        }
        hidden.value = qty;
    }

    if (window.jQuery) {
        window.jQuery(document.body).on('updated_checkout', function () {
            Object.entries(forcedQtyValues).forEach(([cartKey, qty]) => {
                syncForcedQtyInput(cartKey, qty);
            });
        });
    }

    async function runQtyUpdate(cart_item_key, qty) {
        if (isUpdatingQty) {
            pendingQty     = qty;
            pendingCartKey = cart_item_key;
            acLog('[AC-FLOW] runQtyUpdate: queued qty=' + qty + ' (update in progress)');
            return;
        }

        isUpdatingQty = true;
        pendingQty     = null;
        pendingCartKey = null;
        disableQtyButtons();

        try {
            await updateQtyAjax(cart_item_key, qty);
            await updateBeneficiariesForm(qty);
        } finally {
            isUpdatingQty = false;
            if (pendingQty !== null) {
                const nextQty = pendingQty;
                const nextKey = pendingCartKey;
                pendingQty     = null;
                pendingCartKey = null;
                acLog('[AC-FLOW] runQtyUpdate: flushing pending qty=' + nextQty);
                await runQtyUpdate(nextKey, nextQty);
            } else {
                enableQtyButtons();
            }
        }
    }

    function animateQty(input) {
        input.classList.add('is-updating');

        setTimeout(() => {
            input.classList.remove('is-updating');
        }, 180);
    }

    function animatePriceStart() {
        const price = document.querySelector('.price-total');

        if (price) {
            price.classList.add('is-updating');
        }
    }

    function animatePriceEnd() {
        const price = document.querySelector('.price-total');

        if (price) {
            requestAnimationFrame(() => {
                price.classList.remove('is-updating');
            });
        }
    }

    function disableUI() {
        const form = document.querySelector('.woocommerce');
        if (form) form.classList.add('is-disabled');
    }

    function enableUI() {
        const form = document.querySelector('.woocommerce');
        if (form) form.classList.remove('is-disabled');
    }

    function disableQtyButtons() {
        document.querySelectorAll('.qty-minus, .qty-plus').forEach(btn => {
            btn.disabled = true;
        });
    }

    function enableQtyButtons() {
        document.querySelectorAll('.qty-minus, .qty-plus').forEach(btn => {
            btn.disabled = false;
        });
    }

    async function updateQtyAjax(cart_item_key, qty) {
        acLog('[AC-FLOW] updateQtyAjax: key=' + cart_item_key + ' qty=' + qty);
        const data = new URLSearchParams();
        data.append('action', 'update_checkout_qty');
        data.append('nonce', themeVars.nonce);
        data.append('cart_item_key', cart_item_key);
        data.append('qty', qty);

        animatePriceStart();
        const response = await fetch(themeVars.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data.toString(),
        });

        const res = await response.json();
        acLog('[AC-FLOW] updateQtyAjax response: success=' + res.success + ' server_qty=' + res.data?.qty + (res.data?.qty != qty ? ' *** SERVER QTY DIFFERS FROM REQUESTED ***' : ''));

        const cartKey = res.data.cart_item_key;
        const newQty = res.data.qty;

        const input = document.querySelector(
            `.quantity-wrapper[data-cart-item-key="${cartKey}"] .qty-input`
        );

        if (input) {
            input.value = newQty;
        }

        if (res.data?.order_total) {
            const price = document.querySelector('.price-total');

            if (price) {
                price.innerHTML = res.data.order_total;
                animatePriceEnd();
            }
        }

        syncForcedQtyInput(cartKey, newQty);

        return res;
    }

    async function updateBeneficiariesForm(qty) {
        acLog('[AC-FLOW] updateBeneficiariesForm: requesting qty=' + qty);
        disableUI();

        const data = new URLSearchParams();
        data.append('action', 'get_beneficiaries_form');
        data.append('nonce', themeVars.nonce);
        data.append('qty', qty);

        try {
            const response = await fetch(themeVars.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: data.toString(),
            });

            const res = await response.json();
            acLog('[AC-FLOW] updateBeneficiariesForm response: success=' + res.success);

            if (res.success && res.data) {
                const form = document.querySelector('.beneficiaries-form');
                if (form) {
                    form.innerHTML = res.data;
                    refreshBeneficiaryCountrySelects(form);
                    const rendered = form.querySelectorAll('.beneficiary').length;
                    acLog('[AC-FLOW] updateBeneficiariesForm: rendered=' + rendered + ' requested_qty=' + qty + (rendered !== qty ? ' *** MISMATCH ***' : ''));
                }
            }

            return res;
        } finally {
            enableUI();
        }
    }


    document.querySelectorAll('.qty-input').forEach(async function(input) {
    let val = parseInt(input.value, 10);
    const cartKey = input.closest('.quantity-wrapper').dataset.cartItemKey;
    acLog('[AC-FLOW] page load: qty-input key=' + cartKey + ' initial_val=' + val);
    if (isNaN(val) || val > 10) {
      acLog('[AC-FLOW] page load: resetting invalid val=' + val + ' to 1 for key=' + cartKey);
      input.value = 1;
      await updateQtyAjax(cartKey, 1);
    }
  });

    document.querySelectorAll('.quantity-wrapper[data-cart-item-key] .qty-input').forEach(function (input) {
        const cartKey = input.closest('.quantity-wrapper').dataset.cartItemKey;
        const val = parseInt(input.value, 10);
        if (cartKey && !isNaN(val)) {
            syncForcedQtyInput(cartKey, val);
        }
    });

const initialBeneficiaryCount = document.querySelectorAll('.beneficiary').length;
  const initialQtyVals = [...document.querySelectorAll('.qty-input')].map(el => parseInt(el.value, 10));
  acLog('[AC-FLOW] page load: beneficiary_forms=' + initialBeneficiaryCount + ' qty_inputs=' + JSON.stringify(initialQtyVals) + (initialBeneficiaryCount !== initialQtyVals.reduce((a, b) => a + b, 0) ? ' *** MISMATCH ***' : ''));

    document.querySelectorAll('.qty-minus').forEach(btn => {
        btn.addEventListener('click', async function () {
            const wrapper = this.closest('.quantity-wrapper');
            const input = wrapper.querySelector('.qty-input');
            const cart_item_key = wrapper.dataset.cartItemKey;
            let value = parseInt(input.value) || 1;
            acLog('[AC-FLOW] qty-minus click: current=' + value + ' key=' + cart_item_key);
            if (value > 1) {
                value -= 1;
                input.value = value;
                animateQty(input);
                await runQtyUpdate(cart_item_key, value);
            } else {
                acLog('[AC-FLOW] qty-minus: already at min, no change');
            }
        });
    });

    document.querySelectorAll('.qty-plus').forEach(btn => {
        btn.addEventListener('click', async function () {
            const wrapper = this.closest('.quantity-wrapper');
            const input = wrapper.querySelector('.qty-input');
            const cart_item_key = wrapper.dataset.cartItemKey;
            let value = parseInt(input.value) || 1;
            acLog('[AC-FLOW] qty-plus click: current=' + value + ' key=' + cart_item_key);
            if (value < 9) {
                value += 1;
                input.value = value;
                animateQty(input);
                await runQtyUpdate(cart_item_key, value);
            } else {
                acLog('[AC-FLOW] qty-plus: already at max 9, no change');
            }
        });
    });

    document.body.addEventListener('change', async function (e) {
        if (e.target.classList.contains('same-email-toggle')) {
            const index = e.target.dataset.index;
            const emailWrapper = document.querySelector(
                `.email-wrapper[data-index="${index}"]`
            );

            if (emailWrapper) {
                emailWrapper.classList.toggle('collapsed', e.target.checked);
            }
        }

        if (e.target.classList.contains('qty-input')) {
            const wrapper = e.target.closest('.quantity-wrapper');
            const cart_item_key = wrapper.dataset.cartItemKey;

            let value = parseInt(e.target.value) || 1;
            if (value < 1) value = 1;

            acLog('[AC-FLOW] qty-input change: key=' + cart_item_key + ' value=' + value);
            e.target.value = value;
            await runQtyUpdate(cart_item_key, value);
        }
    });


    // Clear billing fields
    ['billing_first_name', 'billing_last_name', 'billing_email', 'billing_phone', 'billing_address_1', 'billing_postcode', 'billing_city'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = '';
    });
}

export { qtyControl };
